import {
  LISTS,
  MAIN_MARKETS,
  PROMOS,
  FULL_TIME_RESULT,
  FTR_GROUP,
  PROMO_GROUP,
  LIST_GROUP
} from "../constants/market-types";

export default () => {
  const marketGroups: { [x: string]: string } = {};

  marketGroups[FULL_TIME_RESULT] = FTR_GROUP;
  MAIN_MARKETS.forEach(market => {
    marketGroups[market] = FTR_GROUP;
  });

  LISTS.forEach(market => {
    marketGroups[market] = LIST_GROUP;
  });

  PROMOS.forEach(market => {
    marketGroups[market] = PROMO_GROUP;
  });

  return marketGroups;
};
